export default "__VITE_ASSET__BHeNN58Q__"